<div style="height: fit-content; max-height: 100%; width: 100%; position: relative; z-index: 5" [hidden]="!showBox ? showBoxClicked() : false">
  <div [ngClass]="!useFixedPosition ? 'container-standard' : 'container-fixed'">
    <div class="form-div" *ngIf="showSearchField">
      <div class="search-bar">
        <input class="search-bar-input" #inputField placeholder="Search" (input)="onInputChange(inputField.value)" />
        <img src="https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/magnifier.svg" class="form-img" />
      </div>
    </div>
    <div class="line"></div>
    <div class="top-bottom-padding" [ngStyle]="{ 'max-height': maxHeight - 43 + 'px' }">
      <div [hidden]="list.length < 1">
        <div class="items-container">
          <div *ngFor="let item of displayedList; trackBy: trackByFn">
            <div class="divider" *ngIf="showDivider(item)"></div>
             <div [ngClass]="item.value !== 'search-box-title' 
              ? ['hovering-item', checkSelectedItems(item) ? 'is-selected' : ''] 
              : 'item-container'">
              <div [ngClass]="item.value !== 'search-box-title' ? 'item' : 'title-item'" (click)="onItemClicked(item)">
                <ng-container *ngIf="item.value !== 'search-box-title'">
                  <img
                    class="checkbox-img"
                    [src]="checkSelectedItems(item) ? iconService.Icon.round_checkbox_grey_tick : iconService.Icon.round_checkbox_grey_empty" />
                </ng-container>

                <label *ngIf="item.value === 'search-box-title'" class="title disable-selection">{{ item.label }}:</label>
                <label
                  *ngIf="item.value !== 'search-box-title'"
                  [ngClass]="checkSelectedItems(item) ? 'item-text-bold' : 'item-text'"
                  [matTooltip]="item?.label"
                  [matTooltipDisabled]="!withHoverEffect"
                  [ngStyle]="{ color: isItemDisabled(item.label) ? '#A6A6A6' : '#222222' }"
                  class="disable-selection item-row">
                  <span class="item-label">{{ item.label }}</span>
                  <ag-label
                    *ngIf="item.subLabel"
                    [label]="item.subLabel"
                    size="small"
                    [color]="subLabelColor || 'Info'"
                    [secondaryColor]="subLabelSecondaryColor || 'Standard'">
                  </ag-label>
                </label>
              </div>
            </div>
          </div>
          <div class="no-result-text" *ngIf="displayedList.length === 0">No results</div>
        </div>
      </div>
    </div>
  </div>
</div>